import * as React from 'react';
import type { Observable } from 'epics/rxjs';
import { isEmpty } from 'lodash';
import type { SaveAttachmentResponse } from 'rest/attachments';
import type { MediaApiUploadToken } from 'rest/portal';
import type { AuthProvider } from '@atlaskit/media-core';
import { Attachments } from '@atlassian/help-center-common-component/attachments';
import { FieldBase } from '@atlassian/help-center-common-component/fields/field-base';
import type { FieldFormProps, AttachmentFile } from '@atlassian/help-center-common-component/fields/types';

interface Props extends FieldFormProps<AttachmentFile[]> {
    portalId: number;
    mediaApiUploadToken: MediaApiUploadToken;
    authProvider: AuthProvider;
    saveAttachment?: (fileId: string) => Observable<SaveAttachmentResponse>;
}

class RequestCreateAttachmentFieldDumb extends React.PureComponent<Props> {
    onChange = (value: AttachmentFile[]) => {
        this.props.onChange && this.props.onChange(this.props.id, value);
    };

    onError = (messages: string[]) => {
        this.props.onError &&
            this.props.onError({
                messages,
                name: this.props.id,
            });
    };

    render() {
        const {
            label,
            description,
            errorMessage,
            mediaApiUploadToken,
            blockFormSubmission,
            required,
            disabled,
            authProvider,
            saveAttachment,
            id,
        } = this.props;
        return (
            <FieldBase
                htmlFor={id}
                label={label}
                description={description}
                required={required}
                errorMessage={errorMessage}
            >
                <Attachments
                    onChange={this.onChange}
                    authProvider={authProvider}
                    collection={mediaApiUploadToken.targetCollection}
                    saveAttachment={saveAttachment}
                    blockFormSubmission={blockFormSubmission}
                    onError={this.onError}
                    disabled={disabled}
                    hasError={!isEmpty(errorMessage)}
                />
            </FieldBase>
        );
    }
}

export default RequestCreateAttachmentFieldDumb;
